export const CATEGORY = {
  NO_ICON_PROVIDED: 'No icon provided for category.',
  NO_ICONS_FOUND: 'No Icons Found!',
  ICON_DIMENSION_LIMIT_EXCEED:
    'Image dimensions should be less than or equal to 256*256',
  CREATED: 'Category created.',
  EXISTS: 'Category with the same name already exists.',
  UPDATED: 'Category updated.',
  DELETED: 'Category deleted.',
  NOT_FOUND: 'Category not found.',
  CONTAIN_SUB_CATEGORIES:
    'Cannot delete because there are sub categories in this category.',
  REORDER: 'Categories reordered.',
} as const;

export const SUB_CATEGORY = {
  CREATED: 'Sub Category created.',
  EXISTS: 'Sub Category with the same name already exists.',
  UPDATED: 'Sub Category updated.',
  DELETED: 'Sub Category deleted.',
  NOT_FOUND: 'Sub Category not found.',
  DEFAULT: 'Cannot update default Sub Category.',
  CONTAIN_PERKS: 'Cannot delete because there are perks in this sub category.',
  REORDER: 'Sub Categories reordered.',
} as const;

export const PERK_CATEGORY = {
  DEFAULT: 'Cannot update default Perk Category.',
  NOT_FOUND: 'Default Perk Category not found.',
  CREATED: 'Default Perk Category created.',
  DELETED: 'Default Perk Category deleted',
  UPDATED: 'Default Perk Category updated',
  EXISTS: 'Default Perk Category with the same name already exists.',
  CONTAIN_PERKS: 'Cannot delete because there are perks in this category.',
  REORDER: 'Default Perk Categories reordered.',
} as const;
